var module = angular.module('octopusApp.accounts');

module.controller('AccountsIndexController', function ($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.accountTypes = [
    // Azure
    { Name: "Azure Subscription", Id: "AzureSubscription",
      SubTypes: [{Id: "AzureSubscription", Description: "Management Certificates"}, {Id: "AzureServicePrincipal", Description: "Service Principals"}],
      Description: "Use _Azure Subscriptions_ to set subscription IDs, management certificates, and service principals to use when deploying to Microsoft Azure."
    },

    // SSH
    {
      Name: "SSH Key Pair", Id: "SshKeyPair", Description: "_SSH Key Pairs_ are used when authenticating to machines running Linux or another Unix-like operating system."
    },

    // Username/Password
    {
      Name: "Username/Password", Id: "UsernamePassword", Plural: "Usernames/Passwords", Description: "Records a username and password pair to use with SSH servers."
    }
  ];

  isLoading.promise(octopusRepository.Accounts.all().then(function(accounts){
    isLoading.promise(octopusRepository.Environments.all().then(function(environments) {
      _.each(accounts, function (account) {
        account.environments = getTags(account.EnvironmentIds, environments);
      });

      _.each($scope.accountTypes, function(accountType){
        accountType.Accounts = !accountType.SubTypes
         ? _.chain(accounts)
           .filter(function(account){ return accountType.Id === account.AccountType;})
           .sortBy('Name')
           .value()
         : _.chain(accounts)
           .filter(function(account){return _.some(accountType.SubTypes, function(subType){ return subType.Id === account.AccountType;});})
           .groupBy(function(account){ return _.find(accountType.SubTypes, function(subType){ return subType.Id === account.AccountType;}).Description;})
           .value();
      });
    }));
  }));

  var getTags = function(allOptions, selectedOptions) {
    if (allOptions.length === 0) {
      return "";
    }

    var result = [];

    _.each(selectedOptions, function (e) {
      if (allOptions.indexOf(e.Id) >= 0) {
        result.push(e.Name);
      }
    });

    return result.join(",");
  };

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/controllers/accounts_index_controller.js
// module id = 6313932764248920
// module chunks = 1